/**
 * Countries Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    partenaires: []
};

// Getters
const getters = {
    partenaires: state => {
        return state.partenaires
    }
};

// Actions
const actions = {
    getPartenaires(context, payload) {
        function successCallback(response) {
            context.commit('getPartenairesHandler', { partenaires: response.data.dictionnaires });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.PartenaireList.List, localToken, successCallback, errorCallback, payload.errorMessages);
    }
};

// Mutations
const mutations = {
    getPartenairesHandler(state, { partenaires }) {
        state.partenaires = partenaires;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}